import { DateTime } from 'luxon';

const reDT = /^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2}):(\d{2}(?:\.\d*)?)((Z|([+-])(\d{2}):(\d{2})))?$/;
export default function dateReviver(key: string, value: any) {
  if (typeof value === 'string') {
    const res = reDT.exec(value);
    if (res) {
      return DateTime.fromISO(value);
    }
  }

  return value;
}
